import {Action} from "@ngrx/store";

export const LOAD_ECOMMERCE_REFUNDS: string = '[ecommerce refunds] Load Ecommerce Refunds';
export const LOAD_ECOMMERCE_REFUNDS_SUCCESS: string = '[ecommerce refunds] Load Ecommerce Refunds Success';
export const LOAD_ECOMMERCE_REFUNDS_FAIL: string = '[ecommerce refunds] Load Ecommerce Refunds Fail';

export class LoadEcommerceRefunds implements Action {
  readonly type: string = LOAD_ECOMMERCE_REFUNDS;

  constructor(public payload: { websiteId: number, orderId: number }) {
  }
}

export class LoadEcommerceRefundsSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_REFUNDS_SUCCESS;

  constructor(public payload: {
    data: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number,
    orderId: number
  }) {
  }

}

export class LoadEcommerceRefundsFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_REFUNDS_FAIL;

  constructor(public payload: any) {
  }

}

export type EcommerceRefundsAction = LoadEcommerceRefunds | LoadEcommerceRefundsSuccess | LoadEcommerceRefundsFail;
